/**
 * @file
 * Commerce: Ajax "Add to cart".
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.medihumCommerceAjaxAddToCart = {
    attach: function (context, settings) {
      var self = this;
      var $modal = $('body .added-to-cart-modal');

      $('form.ajax-add-to-cart-form').once('ajax-add-to-cart-form-process').each(function () {
        self.afterSubmit($(this));
      });

      $('form.ajax-add-to-cart-form').once('quantity-field-processed').each(function () {
        var $field = $(this);

        $field.on('click', 'span.step-down', function (e) {
          e.preventDefault();
          $(this).parent().parent().find('input[name="quantity[0][value]"]')[0].stepDown();
        });

        $field.on('click', 'span.step-up', function (e) {
          e.preventDefault();
          $(this).parent().parent().find('input[name="quantity[0][value]"]')[0].stepUp();
        });
      });

      $('body').on('click', 'a.close-modal', function (e) {
        e.preventDefault();
        self.closeModal($modal);
      });
    },
    afterSubmit: function (wrapper, isModal = false) {
      var self = this;

      wrapper.on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);

        var orderId = $form.data('order-id');

        if (orderId !== undefined) {
          self.buyOrderAgain($form, orderId, isModal);
          return;
        }

        var purchasedEntityType = $form.data('purchased-entity-type');
        var purchasedEntityId = $form.data('purchased-entity-id');
        var qty = $form.find('input[name="quantity[0][value]"]').val();

        if (qty === undefined) {
          qty = Math.floor($form.data('quantity'));
        }

        self.addToCart($form, purchasedEntityType, purchasedEntityId, qty, isModal);
      });
    },
    addToCart: function (form, purchasedEntityType, purchasedEntityId, qty, isModal) {
      var self = this;
      var $modal = $('body .added-to-cart-modal');

      $.ajax({
        url: Drupal.url('cart/add?_format=json'),
        method: 'POST',
        data: {
          purchased_entity_type: purchasedEntityType,
          purchased_entity_id: purchasedEntityId,
          quantity: qty
        },
        success: function (data) {
          if (data.hasOwnProperty('cart')) {
            if (isModal) {
              // mark add to cart button "in-cart" if is triggered from modal
              form.find('.form-actions .form-submit').addClass('in-cart');
            }
            else {
              self.closeModal($modal);
              // append cart result to modal body
              $modal.html(data.build);
              // open modal
              self.openModal($modal);
            }

            // update cart counter and amount
            Drupal.behaviors.medihumGlobal.updateCartCount(data);

            // Send google analytics event
            var settings = drupalSettings.commerceGoogleTagManager || {};
            var url = settings.eventsUrl;
            var dataLayerVariable = settings.dataLayerVariable;

            if (!dataLayerVariable || !window.hasOwnProperty(dataLayerVariable)) {
              return;
            }

            var dataLayer = window[dataLayerVariable];

            $.get(url, function(data) {
              if (data && data.length) {
                data.forEach(function(eventData) {
                  dataLayer.push(eventData);
                });
              }
            });
          }
        }
      });
    },
    buyOrderAgain: function (form, orderId, isModal) {
      var self = this;
      var $modal = $('body .added-to-cart-modal');

      $.ajax({
        url: Drupal.url('buy-again/' + orderId),
        method: 'POST',
        success: function (data) {
          if (data.hasOwnProperty('cart')) {
            if (isModal) {
              // mark add to cart button "in-cart" if is triggered from modal
              form.find('.form-actions .form-submit').addClass('in-cart');
            }
            else {
              self.closeModal($modal);
              // append cart result to modal body
              $modal.html(data.build);
              // open modal
              self.openModal($modal);
            }

            // update cart counter and amount
            Drupal.behaviors.medihumGlobal.updateCartCount(data);
          }
        }
      });
    },
    openModal: function (modal) {
      var self = this;
      var translations = Drupal.behaviors.medihumTranslation.getTranslations();
      var dialog = Drupal.dialog(modal, {
        title: translations.addToCart,
        height: 'auto',
        width: '75%',
        dialogClass: 'cart-modal'
      });

      dialog.showModal();

      modal.find('.buttons-wrapper a.order-now').attr('href', modal.find('.buttons-wrapper a.order-now').attr('href') + '?back=' + drupalSettings.path.currentPath);
      // attach add to cart ajax listener in modal mandatory products
      modal.find('form.ajax-add-to-cart-form').each(function (i, item) {
        self.afterSubmit($(item), true);
      });

      // init slider in modal mandatory products
      if (modal.find('.view-product-accessories').length) {
        Drupal.behaviors.medihumCommerceProduct.buildSlider(modal.find('.view-product-accessories .view-content'), {
          resize: true,
          contain: true,
          groupCells: true,
          prevNextButtons: true,
          pageDots: false,
          freeScroll: true,
          cellAlign: 'left',
        });
      }
    },
    closeModal: function (modal) {
      modal.parent().parent().find('.ui-widget-header .ui-dialog-titlebar-close').click();
    }
  };

})(jQuery, Drupal);
